import { PEV } from "../../../../common/utils";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { patchGroupMembership } from "./service";
import { isNullOrUndefined } from "../../../../common/utils";

export const ErrKeys = {
  USER_GROUP_NOT_FOUND: "USER_GROUP_NOT_FOUND",
  USER_GROUP_NO_PERMISSION: "USER_GROUP_NO_PERMISSION",
  INVALID_CONDITION: "INVALID_CONDITION",
};

const initialState = {
  patchUserGroupMembershipResponse: {
    response: PEV({
      errors: [],
    }),
  },
};

const patchUserGroupMembership = createAsyncThunk(
  "userGroupMembership/patch",
  async (param, { rejectWithValue }) => {
    try {
      return await patchGroupMembership(param.userGroupUniqueName, param.patchMembershipRequest);
    } catch (error) {
      let errorResponse = error?.response?.data;
      if (isNullOrUndefined(errorResponse)) {
        errorResponse = { errors: [{ errorMessage: "Condition not updated" }] };
      }
      return rejectWithValue(errorResponse);
    }
  }
);

const PatchUserGroupMembershipSlice = createSlice({
  name: "userGroupMembership",
  initialState,
  reducers: {},
  extraReducers: {
    [patchUserGroupMembership.pending.type]: (state) => {
      state.patchUserGroupMembershipResponse.response = PEV(
        { ...state.patchUserGroupMembershipResponse.errors },
        "Fetching preview membership"
      );
    },
    [patchUserGroupMembership.fulfilled.type]: (state, action) => {
      state.patchUserGroupMembershipResponse.response = PEV({
        errors: [],
      });
    },
    [patchUserGroupMembership.rejected.type]: (state, action) => {
      state.patchUserGroupMembershipResponse.response = PEV({
        errors: action.payload.errors,
      });
    },
  },
});
export const PatchUserGroupMembershipReducer = PatchUserGroupMembershipSlice.reducer;

export const PatchUserGroupMembershipActions = {
  patchUserGroupMembership,
};
